import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';
import { locationProps } from '../../../../../utils/propTypes';

// Had to manually pass location as prop to nav link to solve a bug
// in connected-react-router with navlinks.
function MenuItem({
  to, label, exact, location, collaboratorsItem,
}) {
  const className = classNames({
    [styles.collaboratorsItem]: collaboratorsItem,
    [styles.item]: !collaboratorsItem,
  });
  const activeClassName = classNames({
    [styles.activeCollaborators]: collaboratorsItem,
    [styles.active]: !collaboratorsItem,
  });
  return (
    <NavLink
      exact={exact}
      to={to}
      className={className}
      activeClassName={activeClassName}
      location={location}
    >
      {label}
    </NavLink>
  );
}

MenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  exact: PropTypes.bool,
  location: locationProps.isRequired,
  collaboratorsItem: PropTypes.bool,
};

MenuItem.defaultProps = {
  exact: false,
  collaboratorsItem: false,
};

function mapStateToProps({ router }) {
  return router;
}

export default connect(mapStateToProps)(MenuItem);



// WEBPACK FOOTER //
// ./src/app/components/NavigationBar/components/MenuItem/index.js